import { Controller } from 'stimulus';

export default class extends Controller {

  connect(){
    var checked = document.querySelector('input[data-action="auth--sign-up#change_type"][checked="checked"]');
    const companyInputs = document.querySelector('.company-inputs');
    if (checked && checked.value == 'true') {
      companyInputs.classList.add('is-hidden');
      companyInputs.querySelectorAll('input').forEach(function(element) {
        element.disabled = true;
      });
    }; 
    if (checked && checked.value == 'false') {
      companyInputs.classList.remove('is-hidden');
      companyInputs.querySelectorAll('input').forEach(function(element) {
        element.disabled = false;
        if(element.classList.contains('company-inn-input')) {
          element.required = true;
        }
      });
    };

  }

  change_type () {
    const companyInputs = document.querySelector('.company-inputs');
    companyInputs.classList.toggle('is-hidden');

    if (companyInputs.classList.contains('is-hidden')) {
      companyInputs.querySelectorAll('input').forEach(function(element) {
        element.disabled = true;
      });
    } else {
      companyInputs.querySelectorAll('input').forEach(function(element) {
        element.disabled = false;
        if(element.classList.contains('company-inn-input')) {
          element.required = true;
        }
      });
    }
  }
}
